import { useTranslation } from "react-i18next";

import { Page, PageContextProvider } from "@digital-services/shell";
import { CenterContent, CenteredCard, Typography } from "@digital-services/ui";

const appName = import.meta.env.VITE_APP_APPLICATION_NAME || "";

// No replacement similar component in from "@digital-services/auth";
// But there is SignInErrorPage.tsx, not sure
export function SigningOutPage() {
  const { t } = useTranslation(undefined, { keyPrefix: "account.signing-out" });

  return (
    <PageContextProvider applicationName={appName}>
      <div className="flex h-screen">
        <CenterContent>
          <CenteredCard>
            <Page title={t("page_title")}>
              <Typography variant="description" className="mt-2 mb-2">
                {t("description")}
              </Typography>
            </Page>
          </CenteredCard>
        </CenterContent>
      </div>
    </PageContextProvider>
  );
}
